// @core/api/endpoints/workflow/create_pipeline_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePipelinePolicyRequest,
  PipelinePolicyResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create pipeline policy
 * Creates a pipeline policy for a scope entity (organization, team, department). Configures allowed node types, execution limits, and approval requirements.
 */
export async function CreatePipelinePolicy(
  data: CreatePipelinePolicyRequest,
  options?: RequestOptions
): Promise<PipelinePolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/pipeline-policies`;
  const requestOptions = options;
  return client.post<PipelinePolicyResponse>(requestPath, data, requestOptions);
}
